export enum DotsSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

interface Props {
  size?: DotsSize;
  color?: string;
}

const dotsTheme = {
  [DotsSize.LARGE]: 'w-6 h-6',
  [DotsSize.MEDIUM]: 'w-5 h-5',
  [DotsSize.SMALL]: 'w-3.5 h-3.5',
};

export const DotsLoading: React.FC<Props> = ({ size = DotsSize.SMALL, color = 'bg-neutral-400' }) => {
  return (
    <div className="w-full h-full flex gap-2 items-center justify-center" data-test-id="dots-loading">
      <div className={`${dotsTheme[size]} ${color} rounded-full animate-pulse-loading`} />
      <div
        className={`${dotsTheme[size]} ${color} rounded-full animate-pulse-loading`}
        style={{ animationDelay: '250ms' }}
      />
      <div
        className={`${dotsTheme[size]} ${color} rounded-full animate-pulse-loading`}
        style={{ animationDelay: '500ms' }}
      />
    </div>
  );
};
